import * as dc from "@/components/layout/list/defaultType";
import { RefObject } from "react";
import { DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { FormInstance } from "antd";
import { convertFormValues, getFormDateDiff, runFormFunction } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { fetchCommand } from "@/util/fetchutil";
import { getApiHostname } from "@/util/paramutil";
import { DataCols, DataColumnRecord } from "../../input/inputType";
import { brewingCommon, brewingDefault, brewingInit, brewingType, getBrewingStep } from "../../inputCols/brewingCols";
import { brewingClipboard } from "../../inputCols/clipboard";
import { checkEmpty } from "@/util/stringutil";
import { enLocale } from "@/i18n/routing";
export const CafeBrewing = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;

  const utcOffset = dayjs().utcOffset() * 60000;
  let readOnlyMode = false;

  switch (params?.page.page ?? "") {
    case "CafeBrewingToday":
      readOnlyMode = true;
    case "CafeBrewingResult":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/cafe/brewing/result/detail/",
          saveFetch: { fetchUrl: "/api/cafe/brewing/result/edit" },
        },
        listFetch: { fetchUrl: "/api/cafe/brewing/result/list" },
        dataResultName: "detail_result",
        dataMerge: "detail_result_step",
        dataName: "CafeBrewingResultData",
        dataScrollAnimate: false,
        editReload: true,
        editCheck: true,
        clipboard: brewingClipboard,
        dataInit: (data: any) =>
          brewingInit(form?.current, formFunction?.current, dataFunction?.current, data, params?.setTimer),
        writeButton: !readOnlyMode,
        saveButton: !readOnlyMode,
        editButton: !readOnlyMode,
        dataCols: {
          brewing_result_date: {
            ...dc.date,
            labelClassName: dc.strongLabelClassName,
            required: true,
            update: { disabled: true },
          },
          brewing_seq: {
            ...dc.brewingSelect(params?.locale, false),
            label: "brewing_info",
            labelClassName: dc.strongLabelClassName,
            dataUrl: "/api/cafe/brewing/default/code",
            dataProp: {
              load: (data, select_data) => {
                Debug(data, select_data);
              },
            },
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "brewing_seq", "selectData");
              if (temp_result.result) {
                Debug(temp_result.result);
                const convert_values = convertFormValues(formMemo?.current, temp_result.result, undefined, []);
                if (convert_values) {
                  if (checkEmpty(form?.current?.getFieldValue("brewing_result_date"))) {
                    convert_values["brewing_result_date"] = dayjs();
                  }
                  // convert_values["brewing_result_use"] = 1;
                  form?.current?.setFieldsValue(convert_values);
                  // runFormFunction(formFunction?.current, "received_seq", "changeLoad");
                  // runFormFunction(formFunction?.current, "blending_result_seq", "changeLoad");
                }
                setTimeout(() => {
                  runFormFunction(formFunction?.current, "received_seq", "changeLoad");
                }, dc.setTimeoutShort);
                brewingInit(
                  form?.current,
                  formFunction?.current,
                  dataFunction?.current,
                  convert_values,
                  params?.setTimer,
                );
              }
            },
            // selectChangeLoad: ["received_seq"],
            tooltip: true,
            tooltipTransition: false,
          },

          coffeebean_seq: {
            ...dc.selectSearch,
            label: "use_coffeebean_label",
            labelClassName: dc.strongLabelClassName,
            inputClassName: dc.greenbeanSeqWidth,
            dataValueList: ["coffeebean_list"],
            edit: { dataUrl: "/api/cafe/coffeebean/default/code" },
            dataProp: {
              load: (data, select_data) => {
                Debug(data, select_data);
              },
            },
            widthFull: true,
            dataLabel: {
              value: "coffeebean_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "coffeebean_name", subs: "coffeebean_nick" }
                  : { field: "coffeebean_name_locale", subs: "coffeebean_nick_locale" },
              ],
              labelSort: true,
            },
            read: { display: "notNull" },
            selectChangeLoad: ["received_seq"],
            onChange: (data) => {},
            changePass: true,
            tooltip: true,
            tooltipTransition: false,
          },

          received_seq: {
            ...dc.selectSearch,
            label: "use_received_label",
            labelClassName: dc.strongLabelClassName,
            inputClassName: dc.greenbeanSeqWidth,
            dataValueList: ["received_list"],
            edit: { dataUrl: "/api/cafe/coffeebean/received/code" },
            dataProp: {
              // load: (data, select_data) => {
              //   Debug(data, select_data);
              // },
            },
            widthFull: true,
            selectFieldFilter: { coffeebean_seq: "coffeebean_seq" },
            selectFieldRequired: "coffeebean_seq",
            dataLabel: {
              value: "received_seq",
              label: ["received_date", "received_div"],
              labelSort: true,
            },
            onChange: (data) => {
              const temp_result = runFormFunction(formFunction?.current, "received_seq", "selectData");
              if (temp_result.result) {
                Debug(temp_result.result);
                const convert_values = convertFormValues(
                  formMemo?.current,
                  temp_result.result,
                  ["blending_result_date", "blending_loss", "blending_organic_loss"],
                  [],
                );
                form?.current?.setFieldsValue(convert_values);
                form?.current?.setFieldValue(
                  "brewing_date_term",
                  getFormDateDiff(form?.current, "blending_result_date", "brewing_result_date"),
                );
              }
            },
            changePass: true,
            tooltip: true,
            tooltipTransition: false,
          },
          menu_seq: {
            ...dc.selectSearch,
            label: "menu_label",
            inputClassName: dc.greenbeanSeqWidth,
            dataValueList: ["menu_list"],
            dataUrl: "/api/cafe/menu/default/code",
            dataProp: { fixedParam: { menu_coffee_use: true } },
            widthFull: true,
            dataLabel: {
              value: "menu_seq",
              label: params?.locale === enLocale ? "menu_name" : "menu_name_locale",
              labelSort: false,
            },
            read: { display: "notNull" },
            changePass: true,
            tooltip: true,
            tooltipTransition: false,
          },
          blending_result_date: {
            // itemClassName: "hidden",
            fieldId: {
              blending_result_date: {
                ...dc.date,
                dateProp: { nowButton: false },
                disabled: true,
                noItem: false,
                // update: { disabled: true },
              },
              brewing_date_term: {
                ...dc.number,
                inputClassName: "text-last",
                unitPrev: "+",
                unit: { element: "day_unit", transition: true },

                noItem: false,
                disabled: true,
                tooltip: "brewing_date_term",
              },
            },
          },
          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "cafe",
            "result",
            false,
          ),
          condition: {
            label: "blank",
            labelClassName: dc.mobileHidden,
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["outside_air", "inside_air", "outside_hum", "inside_hum"] },
            fieldId: {
              condition_air: {
                ...dc.airTemp,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
              },
              condition_hum: {
                ...dc.hum,
                readOnly: true,
                disabled: true,
                variant: "borderless",
                unit: "",
                read: { display: "notNull", displayCheckIds: ["outside_hum", "inside_hum"] },
              },
            },
          },
          outside: {
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["outside_air", "outside_hum"] },
            edit: { label: dc.weatherButton(form) },
            fieldId: {
              outside_air: dc.airTemp,
              outside_hum: { ...dc.hum, read: { display: "notNull", displayCheckIds: undefined } },
            },
          },
          inside: {
            itemClassName: "brewing_result",
            read: { display: "notNull", displayCheckIds: ["inside_air", "inside_hum"] },
            fieldId: {
              inside_air: dc.airTemp,
              inside_hum: { ...dc.hum, read: { display: "notNull", displayCheckIds: undefined } },
            },
          },
          brewing_satis: {
            ...dc.rateInput,
            iconName: "Coffee",
            read: { variant: undefined, display: "notNull" },
            create: { defaultValue: 10 },
          },
          brewing_result_main: { ...dc.use, itemClassName: "brewing_result" },
          brewing_default_memo: { ...dc.textAreaM },
          // brewing_public: { ...dc.use, itemClassName: "brewing_result" },
          rgst_by: { ...dc.rgst, display: !readOnlyMode },
          edit_by: { ...dc.edit, display: !readOnlyMode },
        },
        listColLinkField: ["brewing_result_date", "brewing_result_seq"],

        listColDesc: dc.brewingSummary(params?.locale),

        listSearch: [
          { ...dc.select, field: "search3", codeGroup: "EXTR", label: "brewing_type", placeholder: "brewing_type" },
          {
            ...dc.date,
            field: "search0",
            label: "brewing_result_date",
            placeholder: "brewing_result_date",
            defaultValue: undefined,
          },
          {
            ...dc.date,
            field: "search1",
            label: "blending_result_date",
            placeholder: "blending_result_date",
            defaultValue: undefined,
          },
          {
            ...dc.listSearchUse,
            field: "search2",
            label: "brewing_result_main",
            placeholder: "brewing_result_main",
            defaultValue: readOnlyMode ? 1 : undefined,
          },
        ],

        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "coffeebean_name_locale", placeholder: "coffeebean_name" },
          // { ...dc.input, field: "search_type0", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type1", label: "brewing_name", placeholder: "brewing_name" },
        ],
        listOrder: [
          "brewing_result_date_orderdesc",
          "brewing_result_date_orderasc",
          "brewing_result_main_orderdesc",
          "brewing_result_main_orderasc",
        ],

        listColBold: [
          "brewing_result_date",
          params?.locale === enLocale ? "coffeebean_name" : "coffeebean_name_locale",
        ],
        listColDescBold: ["brewing_date_term", "brewing_grinder_point"],

        listCols: [
          // "roaster_seq",
          // "blending_seq",
          {
            field: "brewing_result_date",
            fieldId: {
              brewing_result_date: { ...dc.date, dateFormatter: "YY-MM-DD" },
              brewing_date_term: {
                prev: { element: "+", transition: false },
                next: { element: "day_unit", transition: true },
              },
            },
            valueJoin: " / ",
          },
          // "blending_result_date",
          params?.locale === enLocale ? "coffeebean_name" : "coffeebean_name_locale",
          // "brewing_result_seq",
          {
            field: "brewing_grinder_point",
            scale: 100,
            fieldId: {
              brewing_grinder_point: { scale: 100 },
              brewing_grinder_zeropoint: {
                scale: 100,
                // prev: { element: "(", transition: false },
                // next: { element: ")", transition: false },
              },
            },
            valueJoin: " / ",
          },
          {
            field: "brewing_bean_mass",
            label: "brewing_info",
            fieldId: {
              brewing_bean_mass: { ...dc.mass },
              brewing_mass: { ...dc.mass },
              brewing_term: { ...dc.secondTimer(params?.locale) },
            },
            valueJoin: " / ",
          },
          // { field: "brewing_grinder_zeropoint", label: "grinder_zeropoint", scale: 100 },
          // "brewing_date_term",
          // { field: "blending_loss", label: "loss_rate", scale: 10, unit: "%" },
          // { field: "brewing_mass", ...dc.mass },
          { field: "blending_loss", label: "loss_rate", ...dc.lossRate },
          !readOnlyMode
            ? {
                field: "brewing_result_main",
                label: "cupnote_main_list_label",
                transition: true,
                valueList: dc.listUseLabel,
              }
            : "",
        ],
        listColMobileTitle: params?.locale === enLocale ? "coffeebean_name" : "coffeebean_name_locale",
        mobileHidden: ["brewing_date_term"],
      };

    //추출기본설정
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_default","system_table_pk":["cafe_seq","brewing_seq"],"system_table_manual_increment":"brewing_seq","system_table_page":"CafeBrewingDefault","system_table_path":"api/cafe/brewing/default","system_table_page_name":"CafeBrewingDefault","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result","system_table_search_column":["brewing_type","brewing_public"],"system_table_search_select":["brewing_name_locale","brewing_name"],"system_table_order_column":["brewing_type"],"system_table_default_name_column":"brewing_name_locale","system_table_en_name_column":"brewing_name","system_table_use_column":"brewing_use"}
    //--info--}

    //추출단계
    //--info--{
    //--info--"table":{"system_TABLE_SCHEMA":"clm_roaster","system_TABLE_NAME":"brewing_default_step","system_table_pk":["cafe_seq","brewing_seq"],"system_table_page":"CafeBrewingDefaultStep","system_table_path":"api/cafe/brewing/defaultstep","system_table_page_name":"CafeBrewingDefaultStep","system_table_auth":["SADMIN","ADMIN","USER"],"system_select_auth":["roaster"],"system_roaster_auth":"ROASTER","system_table_mapper":"roasterqc","system_table_detail_result":"detail_result"}
    //--info--}

    case "CafeBrewingDefault":
      return {
        ...result,
        dataFetch: {
          fetchUrl: "/api/cafe/brewing/default/detail/",
          saveFetch: { fetchUrl: "/api/cafe/brewing/default/edit" },
        },
        listFetch: { fetchUrl: "/api/cafe/brewing/default/list" },
        dataResultName: "detail_result",
        dataMerge: "detail_result_step",
        dataName: "CafeBrewingDefaultData",
        editReload: true,
        clipboard: brewingClipboard,
        dataInit: (data: any) =>
          brewingInit(form?.current, formFunction?.current, dataFunction?.current, data, params?.setTimer),
        dataCols: {
          brewing_name_locale: {
            ...dc.inputFull,
            minLength: params?.locale !== enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale !== enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          brewing_name: {
            ...dc.inputFull,
            minLength: params?.locale === enLocale ? 3 : undefined,
            maxLength: 300,
            showCount: true,
            labelClassName: dc.strongLabelClassName,
            required: params?.locale === enLocale ? true : undefined,
            read: { variant: "borderless" },
          },
          coffeebean_seq: {
            ...dc.selectSearch,
            label: "use_coffeebean_label",
            inputClassName: dc.greenbeanSeqWidth,
            dataUrl: "/api/cafe/coffeebean/default/code",
            dataProp: {
              load: (data, select_data) => {
                Debug(data, select_data);
              },
            },
            widthFull: true,
            dataLabel: {
              value: "coffeebean_seq",
              label: [
                params?.locale === enLocale
                  ? { field: "coffeebean_name", subs: "coffeebean_nick" }
                  : { field: "coffeebean_name_locale", subs: "coffeebean_nick_locale" },
              ],
              labelSort: true,
            },
            onChange: (data) => {},
            create: { dataProp: { firstReload: true } },
            read: { display: "notNull" },
            tooltip: true,
            tooltipTransition: false,
          },
          ...brewingDefault(
            t,
            form,
            formMemo?.current,
            formFunction?.current,
            dataFunction?.current,
            params?.setTimer,
            params?.locale,
            "cafe",
            "default",
            true,
          ),
          // brewing_public: { ...dc.use },
          public_type: { ...dc.publicType },
          public_uuid: { ...dc.publicUUID("/info/brewing/cafe/") },
          brewing_use: { ...dc.useDefault },

          rgst_by: { ...dc.rgst },
          edit_by: { ...dc.edit },
        },
        listColLinkField: "brewing_seq",
        listColDesc: dc.brewingSummary(params?.locale),
        listColDescBold: [
          params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
          "brewing_grinder_point",
        ],
        listSearch: [
          { ...dc.select, field: "search0", codeGroup: "EXTR", label: "brewing_type", placeholder: "brewing_type" },
          { ...dc.listSearchUse, field: "search1", label: "brewing_public", placeholder: "brewing_public" },
        ],
        listSearchSelect: [
          { ...dc.input, field: "search_title_all", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type0", label: "brewing_name_locale", placeholder: "brewing_name_locale" },
          // { ...dc.input, field: "search_type1", label: "brewing_name", placeholder: "brewing_name" },
        ],
        listOrder: ["brewing_type_orderasc", "brewing_type_orderdesc"],
        listCols: [
          // "cafe_seq",
          // "brewing_seq",
          { field: "brewing_type", codeGroup: "EXTR" },
          params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
          {
            field: "brewing_grinder_point",
            scale: 100,
            fieldId: {
              brewing_grinder_point: { scale: 100 },
              brewing_grinder_zeropoint: {
                scale: 100,
                // prev: { element: "(", transition: false },
                // next: { element: ")", transition: false },
              },
            },
            valueJoin: " / ",
          },
          {
            field: "brewing_bean_mass",
            label: "brewing_info",
            fieldId: {
              brewing_bean_mass: { ...dc.mass },
              brewing_mass: { ...dc.mass },
              brewing_term: { ...dc.secondTimer(params?.locale) },
            },
            valueJoin: " / ",
          },
          // { field: "brewing_grinder_point", scale: 100 },
          // { field: "brewing_bean_mass", ...dc.mass },
          // { field: "brewing_mass", ...dc.mass },
          { field: "public_type", codeGroup: "PBTP" },
        ],
        listColMobileTitle: params?.locale === enLocale ? "brewing_name" : "brewing_name_locale",
        // mobileHidden: ["brewing_type", "brewing_public"],
      };
    default:
      return undefined;
  }
};
